function componentWillUnmount () {
  // let sidebarList = document.getElementById('notificationSidebar')
  // sidebarList.onscroll = undefined
}

export default componentWillUnmount
